<template>
    <div>
        <div>
            <div class="common-search">
                <el-select
                        style="margin-right: 10px"
                        v-model="roomPaths"
                        multiple
                        placeholder="请选择房间类型">
                    <el-option
                            v-for="item in roomPathsArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-date-picker
                        v-model="date"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"/>

                <el-button type="primary" @click="getList()">搜索</el-button>
                <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="platformUserStats.beanList"
                    @sort-change="sortChange"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="玩家ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column sortable="custom" align="center" width="120" label="总积分" prop="totalIntegral">
                  <template slot-scope="scope">
                    {{scope.row.totalIntegral|numberChip}}
                  </template>
                </el-table-column>
                <el-table-column sortable="custom" align="center" width="120" label="总保险" prop="totalInsurance"/>
                <el-table-column sortable="custom" align="center" width="120" label="总手数" prop="totalHand"/>
                <el-table-column sortable="custom" align="center" width="120" label="总房间数" prop="totalRoom"/>
                <el-table-column sortable="custom" width="150" align="center" label="总带入次数" prop="totalBringTimes"/>
                <el-table-column sortable="custom" align="center" width="120" label="JP贡献值">
                  <template slot-scope="scope">
                    {{scope.row.totalJp | numberChip}}
                  </template>
                </el-table-column>
                <el-table-column sortable="custom" align="center" width="120" label="JP击中值">
                  <template slot-scope="scope">
                    {{scope.row.totalJpProfit | numberChip}}
                  </template>
                </el-table-column>
                <el-table-column label="用户层级" min-width="150" align="center">
                    <template slot-scope="scope">
                        {{userLevelArr[scope.row.userLevel]}}
                    </template>
                </el-table-column>
                <el-table-column label="战绩流水" min-width="150" align="center">
                  <template slot-scope="scope">
                    {{scope.row.totalPlAbs | numberChip}}
                  </template>
                </el-table-column>
                <el-table-column label="所属俱乐部" min-width="150" align="center" prop="clubName"/>

                <el-table-column label="常用设备" min-width="150" align="center">
                    <template slot-scope="scope">{{scope.row.commonEquipment | equipmentName}}</template>
                </el-table-column>
                <el-table-column label="最近带入地点" min-width="150" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.currentEquipment === 'simulator'">虚拟定位</template>
                        <location-to-city v-else
                                          :location="`${scope.row.bringLongitude},${scope.row.bringLatitude}`"/>
                    </template>
                </el-table-column>
                <el-table-column label="常用IP" width="150" align="center" prop="commonIpLocation"/>
                <el-table-column label="注册时间" width="150" align="center" prop="registrationTime"/>
                <el-table-column label="最后一次登录时间" width="150" align="center" prop="lastLoginTime"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="platformUserStats.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import locationToCity from 'components/locationToCity'

    export default {
        components: {
            locationToCity,
        },
        data() {
            return {
                loading: false,
                orderDirection: '',// 排序方向 升序：asc 降序：desc
                orderField: '',// 排序字段
                roomPathsArr: [{label: '普通局', value: 61}, {label: '奥马哈', value: 91}],
                roomPaths: [],
                date: null,
                platformUserStats: {// 平台玩家牌局信息
                    beanList: [],
                    total: 0,
                },
                currentPage: 1
            }
        },
        computed: {
            ...mapGetters('user', ['userLevelArr']),
            ...mapState('login', ['permissions'])
        },
        created() {
            this.getUserLevelConfigList();
        },
        methods: {
            ...mapActions('user', ['getUserLevelConfigList']),
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getPlatformUserStats']),
            sortChange(e) {
                let orderField = ['', 'totalIntegral', 'totalInsurance', 'totalHand', 'totalRoom', 'totalBringTimes', 'totalJp', 'totalJpProfit'];
                this.orderDirection = e.order ? e.order === 'descending' ? 'desc' : 'asc' : '';
                this.orderField = e.prop ? orderField.indexOf(e.prop) : '';
                this.getList()
            },

            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.roomPaths.length) {
                    this.$message.error('请选择房间类型');
                    return false
                }
                return true
            },
            getList(page = 1) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                this.currentPage = 1;
                this.getPlatformUserStats({
                    orderDirection: this.orderDirection,
                    orderField: this.orderField,
                    roomPaths: this.roomPaths,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page
                }).then(res => {
                    this.platformUserStats = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/gameDetail/platform/user/stats/export',
                    info: [
                        {name: 'roomPaths', value: this.roomPaths.join(',')},
                        {name: 'startTime', value: this.date ? this.date[0] : ''},
                        {name: 'endTime', value: this.date ? this.date[1] : ''},
                    ]
                });
            }
        }
    }
</script>